export type CompanyUsageItem = {
  metric: string;
  used: number | null;
  included: number | null;
  overage: number | null;
  overageAmount: number | null;
  unlimited: boolean;
  measurement: 'current' | 'unavailable';
};
export type CompanyUsageReport = { success: true; organizationId: string; usage: CompanyUsageItem[] };
export function validCompanyUsage(value: unknown): value is CompanyUsageReport {
  if (!value || typeof value !== 'object') return false;
  const report = value as CompanyUsageReport;
  return report.success === true && typeof report.organizationId === 'string' && Array.isArray(report.usage)
    && new Set(report.usage.map(item => item?.metric)).size === report.usage.length
    && report.usage.every(item => !!item && typeof item.metric === 'string'
      && (item.included === null || Number.isSafeInteger(item.included) && item.included >= -1)
      && item.unlimited === (item.included === -1)
      && (item.measurement === 'unavailable' && item.used === null && item.overage === null && item.overageAmount === null
        || item.measurement === 'current' && Number.isSafeInteger(item.used) && item.used! >= 0
          && (item.overage === null || Number.isSafeInteger(item.overage) && item.overage >= 0)
          && (item.overageAmount === null || Number.isSafeInteger(item.overageAmount) && item.overageAmount >= 0)));
}
export function companyUsageDisplay(item: CompanyUsageItem) {
  const labels: Record<string, string> = { orders_synced: 'Monthly order imports', products_synced: 'Monthly product imports', team_members: 'Active company members', shops_connected: 'Warehouse accounts', api_calls: 'API requests' };
  const known = item.measurement === 'current' && item.used !== null;
  const limit = item.included === null ? 'Not configured' : item.unlimited ? 'Unlimited' : item.included.toLocaleString();
  const percentage = !known || item.included === null || item.unlimited ? null : item.included === 0 ? (item.used! > 0 ? 100 : 0) : Math.min(100, Math.round(item.used! / item.included * 100));
  return { label: labels[item.metric] || item.metric, used: known ? item.used!.toLocaleString() : 'Not measured', limit, percentage,
    overLimit: known && item.included !== null && !item.unlimited && item.used! > item.included };
}
